const NAPIRE_MEDIA = {
    heroVisual: "assets/hero-visual.png",
    heroVideo: "assets/hero-video.mp4",
    serviceAiDx: "assets/service-ai-dx.png",
    serviceSaasCloud: "assets/service-saas-cloud.png",
    serviceDrone: "assets/service-drone.png",
    aboutVisual: "assets/about-visual.png",
    workThumb: "assets/work-thumb.png",
    workCases: {
        droneAgri: "assets/work-case-drone-agri.png",
        disasterWaste: "assets/work-case-disaster-waste.png",
        pricingAi: "assets/work-case-pricing-ai.png",
        ragChat: "assets/work-case-rag-chat.png",
        safetyNlp: "assets/work-case-safety-nlp.png",
        energyForecast: "assets/work-case-energy-forecast.png",
        receiptOcr: "assets/work-case-receipt-ocr.png"
    },
    team: {
        riku: "assets/team-riku.png",
        hirata: "assets/team-hirata.png",
        aimoto: "assets/team-aimoto.png",
        nakano: "assets/team-nakano.png",
        kodaka: "assets/team-kodaka.png",
        mahmoud: "assets/team-mahmoud.png",
        ishibashi: "assets/team-ishibashi.png",
        nogami: "assets/team-nogami.png",
        nguyen: "assets/team-nguyen.png"
    }
};

//# sourceMappingURL=corporate-site.5d9d5af3.js.map
